export function getTimezoneByCountry(countryName) {
    if (!countryName || typeof countryName !== "string") return "UTC";
    const name = countryName.trim().toLowerCase();

    const timezones = {
        // North & Central America
        united_states: "America/New_York",
        usa: "America/New_York",
        canada: "America/Toronto",
        mexico: "America/Mexico_City",
        costa_rica: "America/Costa_Rica",
        cuba: "America/Havana",
        dominican_republic: "America/Santo_Domingo",
        panama: "America/Panama",

        // South America
        brazil: "America/Sao_Paulo",
        argentina: "America/Argentina/Buenos_Aires",
        chile: "America/Santiago",
        colombia: "America/Bogota",
        peru: "America/Lima",
        venezuela: "America/Caracas",
        ecuador: "America/Guayaquil",
        bolivia: "America/La_Paz",

        // Europe
        united_kingdom: "Europe/London",
        uk: "Europe/London",
        germany: "Europe/Berlin",
        france: "Europe/Paris",
        italy: "Europe/Rome",
        spain: "Europe/Madrid",
        russia: "Europe/Moscow",
        netherlands: "Europe/Amsterdam",
        switzerland: "Europe/Zurich",
        turkey: "Europe/Istanbul",
        greece: "Europe/Athens",
        sweden: "Europe/Stockholm",
        norway: "Europe/Oslo",
        finland: "Europe/Helsinki",
        poland: "Europe/Warsaw",
        portugal: "Europe/Lisbon",
        ireland: "Europe/Dublin",
        austria: "Europe/Vienna",
        belgium: "Europe/Brussels",
        denmark: "Europe/Copenhagen",
        czech_republic: "Europe/Prague",
        hungary: "Europe/Budapest",
        ukraine: "Europe/Kyiv",
        romania: "Europe/Bucharest",

        // Asia
        india: "Asia/Kolkata",
        japan: "Asia/Tokyo",
        china: "Asia/Shanghai",
        singapore: "Asia/Singapore",
        indonesia: "Asia/Jakarta",
        south_korea: "Asia/Seoul",
        saudi_arabia: "Asia/Riyadh",
        uae: "Asia/Dubai",
        pakistan: "Asia/Karachi",
        bangladesh: "Asia/Dhaka",
        sri_lanka: "Asia/Colombo",
        nepal: "Asia/Kathmandu",
        afghanistan: "Asia/Kabul",
        thailand: "Asia/Bangkok",
        vietnam: "Asia/Ho_Chi_Minh",
        philippines: "Asia/Manila",
        malaysia: "Asia/Kuala_Lumpur",
        iran: "Asia/Tehran",
        israel: "Asia/Jerusalem",

        // Africa
        south_africa: "Africa/Johannesburg",
        egypt: "Africa/Cairo",
        nigeria: "Africa/Lagos",
        kenya: "Africa/Nairobi",
        ghana: "Africa/Accra",
        morocco: "Africa/Casablanca",
        algeria: "Africa/Algiers",
        tanzania: "Africa/Dar_es_Salaam",
        ethiopia: "Africa/Addis_Ababa",
        uganda: "Africa/Kampala",
        sudan: "Africa/Khartoum",
        zimbabwe: "Africa/Harare",

        // Oceania
        australia: "Australia/Sydney",
        new_zealand: "Pacific/Auckland",
        fiji: "Pacific/Fiji",
        samoa: "Pacific/Apia",

    };

    if (timezones[name]) return timezones[name];
    const normalized = name.replace(/\s+/g, "_");
    return timezones[normalized] || "UTC";
}